import {
  FETCH_LOAD_ALL_TEMPLATE_REQUEST,
  FETCH_LOAD_ALL_TEMPLATE_SUCCESS,
  FETCH_LOAD_ALL_TEMPLATE_FALUIRE,
} from './loadAllTemplateTypes'

const initialState = {
  loading: false,
  allTemplateList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_ALL_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_ALL_TEMPLATE_SUCCESS : return {
      ...state,
      allTemplateList: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_ALL_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      allTemplateList: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
